module.exports = __webpack_public_path__ + "static/media/mail_icon.46210101.svg";